import axios from 'axios'

export default {
  data () {
    return {
      maxResults: 10,
      minLength: 3,
      searching: false,
      search: '',
      selectedCustomer: null,
      selectedBillingcustomer: null
    }
  },
  watch: {
    search (newValue) {
      if (newValue && newValue.length >= this.minLength) {
        this.searching = true
        this.doSearch(this)
      } else {
        this.clearSearch()
      }
    }
  },
  methods: {
    searchCustomers (search) {
      return new Promise(async (resolve, reject) => {
        let response
        try {
          response = await axios.get(this.baseDomain + this.shopId + '/customers.json?sSearch=' + encodeURIComponent(search) + '&iDisplayStart=0&iDisplayLength=' + this.maxResults + '&iSortingCols=1&iSortCol_0=1&sSortDir_0=asc&apikey=' + this.apiKey)
        } catch(e) {
          resolve([])
          return
        }
        resolve(response.data)
        return
      })
    },
    searchBillingcustomers (search) {
      return new Promise(async (resolve, reject) => {
        let response
        try {
          response = await axios.get(this.baseDomain + this.shopId + '/billingcustomers.json?sSearch=' + encodeURIComponent(search) + '&clients=true&iDisplayStart=0&iDisplayLength=' + this.maxResults + '&iSortingCols=1&iSortCol_0=1&sSortDir_0=asc&apikey=' + this.apiKey)
        } catch(e) {
          resolve([])
          return
        }
        resolve(response.data)
        return
      })
    },
    selectCustomer (customer) {
      this.selectedCustomer = customer
      this.$emit('selectCustomer', customer)
    },
    selectBillingcustomer (customer) {
      this.selectedBillingcustomer = customer
      this.$emit('selectBillingcustomer', customer)
    },
    focusSearch () {
      if (this.$refs && this.$refs.search) {
        this.$refs.search.focus()
      }
    }
  },
  mounted () {
    if (!this.skipFocus) {
      this.focusSearch()
    }
  }
}